import { environment } from '@environments/environment';

function bootstrapApp(): void {
    import('./bootstrap').catch((err: unknown) => {
        console.error(err);
    });
}

if (environment.useMocks) {
    import('@msw/browser').then(({ worker: SetupWorker }) => {
        SetupWorker.start({ onUnhandledRequest: 'bypass' }).then(() => {
            bootstrapApp();
        });
    });
} else {
    bootstrapApp();
}
